import { IonCol, IonGrid, IonRow } from "@ionic/react";
import React, { FC, useState } from "react";
import GoogleCustomersMapV2 from "../extras/GoogleCustomersMapV2";
import SummaryRow from "./StaffHomepage/SummaryRow";
import WelcomeRow from "./StaffHomepage/WelcomeRow";
import NeedsAttentionCol from "./StaffHomepage/NeedsAttentionCol";
import RecentActivityCol from "./StaffHomepage/RecentActivityCol";
import ActionsRow from "./StaffHomepage/ActionsRow";
import { isMobile } from "react-device-detect";

interface IProps {};

const AlphaInsightsStaffHome:FC<IProps> = (props) => {
    const [refreshDate, setRefreshDate] = useState(new Date())
    return <IonGrid >
        <WelcomeRow date={refreshDate}/>
        <SummaryRow setDate={setRefreshDate}/>
        <IonRow>
            {isMobile ?  <IonRow  className="h-100 w-100" style={{flexDirection:'column', padding:'0 1rem', minHeight:'200px'}}>
                    <NeedsAttentionCol/>
                    <RecentActivityCol/>
                </IonRow> : null}
            <IonCol size="12" sizeMd="7" sizeXl="9">
                <IonRow className="ion-justify-content-center">
                    <GoogleCustomersMapV2/>
                </IonRow>
                <ActionsRow/>
            </IonCol>
            <IonCol hidden={isMobile} >
                <IonRow  className="h-100" style={{flexDirection:'column', padding:'0 1rem'}}>
                    <NeedsAttentionCol/>
                    <RecentActivityCol/>
                </IonRow>
            </IonCol>
        </IonRow>
    </IonGrid>
};

export default AlphaInsightsStaffHome;